<template>
    <div class="product-page-footer">
        <ul class="pager">
            <li v-for="page in pagesToShow" :key="page">
                <button class="pager__item" href="#" v-bind:class="{ 'pager__item--active': page === currentpage }" @click="onChange($event, page)">{{page}}</button>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: 'product-page-pagination-component',
        props: ['totalitemcount', 'visiblepagecount', 'currentpage','pagesize'],
        data: function () {
            return {
            }
        },
        computed: {
            pageCount: function () {
                return Math.ceil(this.totalitemcount / this.pagesize);
            },
            pagesToShow: function () {
                let pageBuffer = (this.visiblepagecount - 1) / 2;
                let start = this.currentpage - pageBuffer;
                let end = this.currentpage + pageBuffer;
                if (start <= 0) {
                    end = end + ((start - 1) * - 1);
                    start = 1;
                }
                if (end > this.pageCount) {
                    end = this.pageCount;
                }

                let array = [end - start];
                let index = 0;
                for (let i = start; i <= end; i++) {
                    array[index] = i;
                    index++;
                }

                return array;
            }
        },
        mounted() {
        },
        methods: {
            onChange: function ($event, page) {
                this.$emit("changepage", page);
            }
        }
    }
</script>

<style>
    .hello {
        background-color: #ffe;
    }
</style>